import { __assign } from "tslib";
import { CardHeader, CardPreview, makeStyles, mergeClasses, shorthands, SkeletonItem, } from '@fluentui/react-components';
import React from 'react';
import { useCardStyles } from './RecommendedCardControl.styles';
import { CardHeight } from './StyleConstants';
var useStyles = makeStyles({
    root: __assign({ height: CardHeight }, shorthands.padding('12px')),
    cardHeader: {
        height: '40px',
        marginBottom: '12px',
    },
    fileHeader: {
        alignItems: 'center',
    },
    filePreview: {
        cursor: 'auto',
    },
});
export var RecommendedFileCardControlSkeleton = function () {
    var styles = useStyles();
    var cardStyles = useCardStyles();
    return (React.createElement("div", { className: styles.root },
        React.createElement(CardHeader, { className: styles.cardHeader, image: React.createElement(SkeletonItem, { shape: "circle", size: 32 }), header: React.createElement(SkeletonItem, { shape: "rectangle", size: 12 }), description: React.createElement(SkeletonItem, { shape: "rectangle", size: 8, style: {
                    width: '50%',
                } }) }),
        React.createElement("div", { className: cardStyles.fileInnerDiv },
            React.createElement("div", { className: mergeClasses(cardStyles.secondHeadingBase, styles.fileHeader) },
                React.createElement(SkeletonItem, { shape: "square", size: 24 }),
                React.createElement(SkeletonItem, { shape: "rectangle", size: 16 })),
            React.createElement(CardPreview, { className: mergeClasses(cardStyles.filePreview, styles.filePreview) },
                React.createElement(SkeletonItem, { shape: "square", style: {
                        width: '100%',
                        height: '100%',
                    } })))));
};
//# sourceMappingURL=RecommendedFileCardControlSkeleton.js.map